import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { parseISO, format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isValidUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

export const safeUUID = (str: string | undefined): string | null => {
  if (!str || !isValidUUID(str)) {
    console.warn(`Invalid UUID provided: "${str}"`);
    return null;
  }
  return str;
};

/**
 * Safely formats a date string for display without timezone shifting.
 * Use this instead of `new Date(dateString).toLocaleDateString()` 
 * to prevent dates shifting by one day in certain timezones.
 */
export function formatDateString(dateString: string | null | undefined, formatStr: string = 'M/d/yyyy'): string {
  if (!dateString) return '';
  try {
    return format(parseISO(dateString), formatStr);
  } catch {
    return dateString;
  }
}
